import { Injectable } from '@angular/core';

import {
    DynamicValue, DynamicObjects, GenericValue,
    GUIComponentField, HisUiService, HisGenericValueService
} from 'hisng';

import { DynamicContentUtils } from './dynamic-content-utils';

@Injectable()
export class DynamicFieldValueUtils {

    constructor( private hisUiService: HisUiService,
        private dynamicContentUtils: DynamicContentUtils,
        private genericValueService: HisGenericValueService ) {
    }

    /* set keytableValue for dynamicField with genericValueService */
    public setDynamicFieldKeyTableValues(dynamicObjects: DynamicObjects[], keyTableFieldIdValueMap: Map<string, string>){
        dynamicObjects.forEach( (dynamicObject: DynamicObjects) => {
            if ( dynamicObject.values.length !== null ) {
                dynamicObject.values.forEach( ( dynamicValue: DynamicValue ) => {
                    if ( dynamicValue.source && dynamicValue.source !== 'y/n' &&  dynamicValue.source !== 'cb' ) {
                        this.genericValueService.getValueTypes( dynamicValue.source ).subscribe(
                            ( valueTypes: GenericValue[] ) => {
                                let gValue = valueTypes.find(
                                    ( valueType: GenericValue ) => valueType.id === Number.parseInt( dynamicValue.value, 10 ) );
                                let gValueDefaulttext = gValue ? gValue.defaulttext : '';
                                keyTableFieldIdValueMap.set( dynamicValue.attributeName, gValueDefaulttext );
                            } );
                    }
                });
            }
        });
    }

    public getKeyTableDatasource( dynamicObjects: DynamicObjects[], dynamicField: GUIComponentField ): string {
        if ( dynamicField ) {
            let typeValueSource = this.dynamicContentUtils.getDynamicObjectAttribute(
                dynamicObjects, dynamicField.objectUID, dynamicField.attributeName, 'source' );
            return typeValueSource !== 'y/n' && typeValueSource !== 'cb' ? typeValueSource : null;
        }
        return undefined;
    }

    public getDynamicFieldSimpleValue( dynamicObjects: DynamicObjects[], dynamicField: GUIComponentField ): string {
        let dynamicObjectValue = this.dynamicContentUtils.getDynamicObjectAttribute(
            dynamicObjects, dynamicField.objectUID, dynamicField.attributeName, 'value' );
        if ( dynamicObjectValue === '0' || dynamicObjectValue === '1' ) {
            return dynamicObjectValue === '0'
                ? this.hisUiService.translate( 'de.his.javang.nein.lowercase' )
                : this.hisUiService.translate( 'de.his.javang.ja.lowercase' );
        } else {
            return dynamicObjectValue;
        }
    }

    /* get key table value of dynamicField */
    public getDynamicFieldKeyTableValue( dynamicObjects: DynamicObjects[], dynamicField: GUIComponentField,
        keyTableFieldIdValueMap: Map<string, string> ): string {
        if ( this.getKeyTableDatasource( dynamicObjects, dynamicField ) ) {
            return keyTableFieldIdValueMap.get( dynamicField.attributeName );
        }
        return undefined;
    }
}
